// @ts-ignore
import createTrackingClient from '@seek/seek-impression-tracking';
import setDebug from 'debug';

import { isProd } from 'src/utils/environment';
const debug = setDebug('impression-tracking');

export default isProd()
  ? createTrackingClient('https://tracking.engineering.cloud.seek.com.au/a.png')
  : {
      trackGeneral: (data: any) => {
        debug('trackGeneral', data);
      },
    };
